import React from 'react';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { UpgradeItem } from './UpgradeItem';
import { GlobalHotKeys } from 'react-hotkeys';

class Upgrades extends React.Component {
  state = {
    displayUpgrades: false,
  };

  upgradeAvailability = (item) => {
    const { redux } = this.props;
    //return redux.upgrades.total <= redux.upgrades.tiers[item.tier - 1];
    if (redux.upgrades.total >= redux.upgrades.tiers[item.tier - 1]) {
      if (item.maxLevels <= item.currentLevel) {
        return true;
      } else {
        return redux.resources.coins < item.currentCost;
      }
    } else {
      return true;
    }
  };

  toggleUpgrades = (event) => {
    event.preventDefault();
    if (this.state.displayUpgrades) {
      this.setState({
        displayUpgrades: false,
      });
    } else {
      this.setState({
        displayUpgrades: true,
      });
    }
  };

  render() {
    function groupBy(arr, property) {
      return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) {
          memo[x[property]] = [];
        }
        memo[x[property]].push(x);
        return memo;
      }, {});
    }

    const { upgrades } = this.props.redux;
    const keyMap = {
      TOGGLE_UPGRADES: ['tab'],
    };
    const handlers = {
      TOGGLE_UPGRADES: this.toggleUpgrades,
    };
    let sortedUpgrades = groupBy(upgrades.tier1, 'tier');
    let upgradesTemplate = [];
    for (let i = 1; i <= Object.keys(sortedUpgrades).length; i++) {
      upgradesTemplate.push(
        <h3 key={i}>
          Tier {i}{' '}
          <span>
            <BeenhereIcon />
            {upgrades.tiers[i - 1]}
          </span>
        </h3>
      );
      upgradesTemplate.push(
        sortedUpgrades[i].map(
          function (item, index) {
            return (
              <UpgradeItem
                key={index}
                data={item}
                redux={this.props.redux}
                disabled={this.upgradeAvailability(item)}
              />
            );
          }.bind(this)
        )
      );
    }

    return (
      <React.Fragment>
        <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
        <div
          className={this.state.displayUpgrades ? 'upgrades open' : 'upgrades'}
        >
          <div className="upgrades__container">{upgradesTemplate}</div>
        </div>
      </React.Fragment>
    );
  }
}

export { Upgrades };
